import { computed, makeObservable, observable } from "mobx"
import { formatUnits, parseUnits } from "viem"

import type { LcAddress } from "@/domains/core"
import type { ILockReward, LockRewardStoreDAO } from "@/domains/lock-rewards/types"
import type { TokenStore } from "@/domains/tokens"

export class LockRewardStore implements ILockReward {
  nftId: number
  amount: bigint
  bribeAddress: LcAddress
  poolAddress: LcAddress
  token: TokenStore

  constructor(data: LockRewardStoreDAO) {
    this.nftId = data.nftId
    this.amount = data.amount
    this.bribeAddress = data.bribeAddress
    this.poolAddress = data.poolAddress
    this.token = data.token

    makeObservable(this, {
      nftId: observable,
      amount: observable,
      bribeAddress: observable,
      poolAddress: observable,
      token: observable,
      displayAmount: computed,
      valueUSD: computed,
    })
  }

  get displayAmount(): string {
    return this.formatUnits(this.amount)
  }

  formatUnits(value: bigint): string {
    return formatUnits(value, this.token.decimals)
  }

  get key(): string {
    return [this.nftId, this.bribeAddress.toString(), this.poolAddress.toString(), this.token.address.toString()].join(
      "-",
    )
  }

  parseUnits(value: string): bigint {
    return parseUnits(value, this.token.decimals)
  }

  get valueUSD(): number {
    return Number(this.displayAmount) * this.token.bestPrice
  }
}
